(function () {
  function init(root) {
    if (!root || root.dataset.jpQualityReady === 'true') return;
    root.dataset.jpQualityReady = 'true';

    var openButton = root.querySelector('[data-jp-quality-open]');
    var dialog = root.querySelector('[data-jp-quality-dialog]');
    var closeButtons = root.querySelectorAll('[data-jp-quality-close]');
    if (!openButton || !dialog) return;

    var lastFocusedElement = null;

    function setOpen(open) {
      dialog.hidden = !open;
      openButton.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('jp-quality-scroll-locked', open);
      if (open) {
        lastFocusedElement = document.activeElement;
        var closeButton = dialog.querySelector('.jp-quality__close');
        if (closeButton) closeButton.focus();
      } else if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    openButton.addEventListener('click', function () {
      setOpen(true);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !dialog.hidden) setOpen(false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-jp-quality]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();